import React, { useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { useStore } from "../../pages/market/StoreShell";
import { mk } from "../../lib/marketApi";

const field = "w-full rounded-xl border border-slate-200 bg-white px-3.5 py-3 text-sm text-slate-900 outline-none focus:ring-2 focus:ring-[var(--mk-primary)]";

export const BuyerAuthDialog = () => {
  const { slug, store, authOpen, setAuthOpen, setBuyer } = useStore();
  const [mode, setMode] = useState("login");
  const [f, setF] = useState({ name: "", email: "", password: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const body = mode === "login" ? { email: f.email, password: f.password } : f;
      const d = await mk(`/s/${slug}/buyer/${mode === "login" ? "login" : "register"}`, { method: "POST", body });
      setBuyer(d);
      setAuthOpen(false);
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={authOpen} onOpenChange={setAuthOpen}>
      <DialogContent className="max-w-sm rounded-3xl" data-testid="buyer-auth-dialog">
        <DialogHeader>
          <DialogTitle className="text-xl">{mode === "login" ? "Inicia sesión" : "Crea tu cuenta"}</DialogTitle>
          <p className="text-sm text-slate-500">en {store.name} para comprar y ver tus pedidos</p>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          {mode === "register" && (
            <>
              <input required className={field} placeholder="Nombre completo" value={f.name} onChange={set("name")} data-testid="buyer-name-input" />
              <input className={field} placeholder="WhatsApp / teléfono" value={f.phone} onChange={set("phone")} data-testid="buyer-phone-input" />
            </>
          )}
          <input required type="email" className={field} placeholder="Correo" value={f.email} onChange={set("email")} data-testid="buyer-email-input" />
          <input required type="password" minLength={6} className={field} placeholder="Contraseña (mín. 6)" value={f.password} onChange={set("password")} data-testid="buyer-password-input" />
          {err && <p className="text-sm text-red-600" data-testid="buyer-auth-error">{err}</p>}
          <button
            disabled={busy}
            className="flex w-full items-center justify-center gap-2 rounded-xl py-3 text-sm font-semibold text-white disabled:opacity-60"
            style={{ background: "var(--mk-primary, #2563EB)", color: "var(--mk-on-primary, #fff)" }}
            data-testid="buyer-auth-submit"
          >
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}
            {mode === "login" ? "Entrar" : "Crear cuenta"}
          </button>
        </form>
        <button
          onClick={() => {
            setMode(mode === "login" ? "register" : "login");
            setErr("");
          }}
          className="text-center text-sm text-slate-600 underline-offset-2 hover:underline"
          data-testid="buyer-auth-toggle"
        >
          {mode === "login" ? "¿No tienes cuenta? Regístrate" : "¿Ya tienes cuenta? Inicia sesión"}
        </button>
      </DialogContent>
    </Dialog>
  );
};
